import React from 'react';

const CurrentVisaBulletin: React.FC = () => (
  <div className="static-page">
    <h1>Current Visa Bulletin</h1>
    <p>Check the latest visa bulletin for updates on priority dates and green card availability. For personalized advice, please contact our office.</p>
  </div>
);

export default CurrentVisaBulletin;
